module.exports = __webpack_public_path__ + "img/137.8.a2b80173.png";